<template>
  <section class="sme-underwriting">
    <el-form
      ref="form"
      :rules="rules"
      :model="formData">
      <template>
        <div class="abs-top-right">
          <!--          <v-button @click="handlerBack">Save Quote</v-button>-->
          <v-button @click="handlerBack">Back</v-button>
          <v-button
            type="btn-primary"
            @click="handlerNext(3)">Next</v-button>
        </div>
      </template>
      <div class="underwriting-container">
        <div class="form-half-330">
          <template v-if="step==0">
            <h3 class="color-dark">Basic Information</h3>
            <div class="form-item">
              <span>Business Nature</span>
              <el-form-item
                :rules="rules.select"
                prop="basic_info.bus_nature"
              >
                <v-select
                  v-model="formData.basic_info.bus_nature"
                  :block="true"
                  :list="smeOptions.business_nature" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Is it open for 24 hours?</span>
              <el-form-item
                :rules="rules.select"
                prop="basic_info.bus_hour_24">
                <v-radio-group
                  v-model="formData.basic_info.bus_hour_24"
                  :block="true"
                  :list="smeYesNoOptions" />
              </el-form-item>
            </div>

            <div class="form-item">
              <span>Any claim history in the past 3 years?</span>
              <el-form-item
                :rules="rules.select"
                prop="basic_info.claim_history_ind">
                <v-radio-group
                  v-model="formData.basic_info.claim_history_ind"
                  :block="true"
                  :list="smeYesNoOptions" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span>Have you ever been declined, refused to renew or renewed but subject to special terms or conditions for similar insurance?</span>
              <el-form-item
                :rules="rules.select"
                prop="basic_info.reject_ind">
                <v-radio-group
                  v-model="formData.basic_info.reject_ind"
                  :block="true"
                  :list="smeYesNoOptions" />
              </el-form-item>
            </div>
          </template>
          <template v-if="step==1">
            <h3 class="color-dark">Contents Details</h3>
            <div class="form-item">
              <span>What is sum insured of Contents? (Including furniture, fixtures, fittings, machinery & equipment)</span>
              <el-form-item
                :rules="rules.input"
                prop="content_detail.contents_isrd">
                <v-input
                  v-model="formData.content_detail.contents_isrd"
                  :keyNumber="true"
                  :int="true"
                  prepend="HK$" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span class="sme--content__tip ">
                Exclude articles brittle in nature / plate glass
              </span>
            </div>
            <div class="form-item">
              <span>Any stock to be insured?</span>
              <el-form-item
                :rules="rules.select"
                prop="content_detail.stocks_ind">
                <v-radio-group
                  v-model="formData.content_detail.stocks_ind"
                  :block="true"
                  :list="smeYesNoOptions" />
              </el-form-item>
            </div>
            <div
              v-if="formData.content_detail.stocks_ind!=2"
              class="form-item">
              <span>What is the sum insured of stock?</span>
              <el-form-item
                prop="content_detail.stocks_isrd">
                <v-input
                  v-model="formData.content_detail.stocks_isrd"
                  :keyNumber="true"
                  :int="true"
                  :max="stocks_isrd_max"
                  prepend="HK$"/>
              </el-form-item>
            </div>
            <div class="form-item">
              <span class="sme--content__tip ">
                Exclude stock of goods on consignment
              </span>
            </div>
          </template>
          <template v-if="step==2">
            <h3 class="color-dark">Public Liability Details</h3>
            <div class="form-item">
              <span>Sum Insured of public liability</span>
              <el-form-item>
                <v-input
                  disabled
                  :value="public_liability"
                  prepend="HK$" />
              </el-form-item>
            </div>
            <div class="form-item">
              <span class="sme--content__tip ">
                The quote may not be applicable if there is any outdoor signboard hanged up over 30 feet from floor level, please contact our Customer Service Representatives for further enquiry.              </span>
            </div>
          </template>
        </div>
        <div
          v-if="step==3"
          class="form-half-7">
          <occuption-underwriting ref="occuption"></occuption-underwriting>
        </div>
      </div>
      <template>
        <div class="abs-bottom-right">
          <!--          <v-button @click="handlerBack">Save Quote</v-button>-->
          <v-button @click="handlerBack">Back</v-button>
          <v-button
            type="btn-primary"
            @click="handlerNext(3)">Next</v-button>
        </div>
      </template>
    </el-form>
  </section>
</template>

<script>
import {mapActions} from 'vuex'
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import MixinSME from '@/mixins/sme'
import occuptionUnderwriting from '../component/occuption-underwriting'

export default {
  name: 'beautyUnderwriting',
  components:{
    occuptionUnderwriting
  },
  mixins: [MixinOptions, MixinRules,MixinSME],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        basic_info:{
          bus_nature:null,
          bus_hour_24:null,
          claim_history_ind:null,
          reject_ind:null
        },
        content_detail:{
          contents_isrd:null,
          stocks_ind:null,
          stocks_isrd:0
        },
        pl_detail:{

        },
      },
    }
  },
  computed: {

  },
  watch: {
  },
  methods: {
    ...mapActions('quote', [ 'setQuoteResult', 'updateCarModelOptions']),
    handlerAddOcc(){
      this.formData.occ_arr.push({occ_arr:{}})
    },
    handlerDelOcc(index){
      this.formData.occ_arr.splice(0,index)
    },
    submitForm(){
      this.$refs.form.validate(valid => {
        if(valid) {
          if(this.formData.class_id === 11) {
            // 處理 benefits
            const index = this.formData.form11.benefits.indexOf(2)
            if(index !== -1 && !this.checkRgtnYr) {
              this.formData.form11.benefits.splice(index, 1)
            }
          }
          let params = {
            class_id: this.formData.class_id,
            ...this.formData[`form${this.formData.class_id}`]
          }
          this.$emit('getFormData', {
            params
          })
        }
      })
    },
    handler() {
      return {
        checkData: data => {
          const filterData =  data.filter(item => {
            if(item.is_refer_case === 0 && item.is_error_case === 0) {
              return item
            }
          })
          return filterData.length > 0? true: false
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../underwriting";
</style>
